import { render, staticRenderFns } from "./ciudades.vue?vue&type=template&id=6ab2fda8&scoped=true&"
import script from "./ciudades.vue?vue&type=script&lang=js&"
export * from "./ciudades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab2fda8",
  null
  
)

export default component.exports